/**
 * An equipment card's live tile in the org's units (units slice 2b). Pure, and apart from the card so that file exports
 * only its component.
 */
import { shownFor } from "@/lib/units/display";
import type { DisplayPrefs } from "@/lib/units/prefs";

/** A number as the tile has always written it: whole from 100 up, two places below. */
export function fmt(v: number): string {
  return Math.abs(v) >= 100 ? v.toFixed(0) : v.toFixed(2);
}

/**
 * A live tile's value and unit in the org's units: the live unit (else the template's) is the unit the reading is stored
 * in, and the value moves into the shown unit with it. A metric org, or a unit the choice does not convert, reads the
 * tile it always did.
 */
export function liveTileOf(
  value: number,
  liveUnit: string,
  templateUnit: string | undefined,
  prefs: DisplayPrefs | undefined,
): { value: string; unit: string | undefined } {
  const stored = liveUnit || templateUnit;
  const shown = shownFor(stored ?? "", prefs);
  return { value: fmt(shown.convert(value)), unit: shown.converted ? shown.unit : stored };
}
